import { CARD_ACTION_SUBMIT, CARD_DROPDOWN_ITEM_SUBMIT } from '@actions/types'

export const submitCardDropDownAction = ({ payload }) => ({
  type: CARD_DROPDOWN_ITEM_SUBMIT,
  payload
})

export const submitCardAction = ({ payload }) => ({
  type: CARD_ACTION_SUBMIT,
  payload
})
